import DashboardGenComponent from "@/components/DashboardGenComponent.tsx";
import st from "@/styles/CreditLineLoan.module.scss";
import {useLayoutEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import CommonClass from "@/utils/common";
import SimpleCopyButton from "@/ui/SimpleCopyButton.tsx";
import DashboardClass from "@/utils/dashboard_class";
import Skeleton from '@mui/material/Skeleton';
import StaticRangeSlider from "@/ui/StaticRangeSlider.tsx";
import clsx from "clsx";
import Button from "@/ui/Button.tsx";
import DividerSimple from "@/ui/DividerSimple.tsx";
import {useNavigate, useParams} from "react-router-dom";
import LoanInterface from "@/types_and_interfaces/loan_interface.ts";
import useLoans from "@/hooks/loans.ts";


const CrLinePage = () => {

    const {contract} = useParams()

    const loan = useLoans()
    const {t} = useTranslation()
    const [backUrl, setBackUrl] = useState("")
    // const navigate = useNavigate()
    const credit:LoanInterface | undefined = contract ? loan.getLoanByContract(contract) : undefined
    const is_cr_undefined = typeof credit === "undefined"
    const cr_date = new Date(credit ?  credit?.origin_created_at : "")
    cr_date.setMonth(cr_date.getMonth() + (credit ?  credit?.nr_of_installments : 0));

    const backUrlHandler = () => {
        let ls = localStorage.getItem(CommonClass.local_storage_fields.back_url)
        if(typeof ls === "string") {
            setBackUrl(ls)
        }
    }

    useLayoutEffect(() => {
        backUrlHandler()
    }, []);
    
    return (
        <DashboardGenComponent

            backUrl={Boolean(backUrl.length) ? backUrl : ""}

            // header_type={credit?.r_status === "settled" ? "gray" : (credit?.status === "restant" ? "danger" : "primary")}
            header_type={"primary"}

            responsive1

            heading={
                <div className={st.heading}>
                    {t("credit_details")} <span> {t("contract_nr1")} {contract} </span>
                </div>
            }

            header_content={
                <div
                    style={{padding:is_cr_undefined ? "0" : "16px" }}
                    className={st.header_content}
                >

                    {is_cr_undefined ? (
                        <Skeleton
                            variant="rectangular"
                            sx={{
                                width: "100%",
                                minHeight: "100%",
                                bgcolor: "#969696"
                            }}
                        />
                    ) : (
                        <>
                            <div className={st.center}>
                                <div>
                                    <span>
                                        {t("credit_amount")}
                                    </span>
                                    <strong>
                                        {CommonClass.formatMoneyAmount(Number(credit?.capital))} {t("currency")}
                                    </strong>
                                </div>

                                <div>
                                    <span>
                                        {t("period")}
                                    </span>

                                    <strong>
                                        {credit?.inst_amount} {t("months")}
                                    </strong>
                                </div>

                                <div>
                                    <span>
                                        {t("contract_nr")}
                                    </span>

                                    <strong>
                                        {credit?.urn}
                                    </strong>

                                    <SimpleCopyButton
                                        className={st.copy}
                                        value={credit.urn}
                                    />
                                </div>
                            </div>

                            <div className={st.bottom}>
                                <StaticRangeSlider
                                    max={Number(credit?.capital)}
                                    value={Number(credit?.disc_amount)}
                                    danger={credit?.restant_days > 0}
                                    to_fixed
                                />
                            </div>
                        </>
                    )}

                </div>
            }

            column_center={
                <ColumnRight mobile credit={credit} />
                // !is_cr_undefined ? (
                //     <HistoryComponent payments={userCreditLine?.paymentHistory && userCreditLine.paymentHistory} />
                // ) : (
                //     <CircularProgress
                //         sx={{
                //             display: "block",
                //             margin: "0 auto",
                //             color: "#000",
                //         }}
                //     />
                // )
            }

            column_right={
                <ColumnRight credit={credit} />
            }

        />
    )
}

interface ColumnRProps {
    credit:LoanInterface | undefined
    mobile?:boolean
}

const ColumnRight:React.FC<ColumnRProps> = (props) => {

    const {credit, mobile} = props
    const navigate = useNavigate()
    const {t} = useTranslation()

    return (
        <div className={clsx(st.column_right, mobile && st.mobile)}>
            {(typeof credit?.restant_days === "number" && credit?.restant_days > 0)  && (
                <>
                    <strong className={st.restant_warn}>
                        YOU ARE RESTANT!!!
                    </strong>

                    <div className={st.row}>
                        <span>
                            {t("to_pay")}
                        </span>

                        <strong>
                            {CommonClass.formatMoneyAmount(Number(credit?.disc_amount))} {t("currency")}
                        </strong>
                    </div>

                    <DividerSimple/>

                    <div className={clsx(st.row, st.penalities)}>
                        <span>
                            {t("penalities")}
                        </span>

                        <strong>
                            {CommonClass.formatMoneyAmount(Number(credit?.disc_amount))} {t("currency")}
                        </strong>
                    </div>

                    <DividerSimple/>

                </>
            )}

            <div className={clsx(st.row, st.total)}>
                {(typeof credit?.restant_days === "number" && credit?.restant_days > 0)  ? (
                    <span>
                        {t("total")}
                    </span>
                ) : (
                    <span>
                        {t("to_pay")}
                    </span>
                )}

                <strong>
                    {credit?.disc_amount && CommonClass.formatMoneyAmount(Number(credit?.disc_amount))} {t("currency")}
                </strong>
            </div>

            <Button onClick={() => {
                navigate(DashboardClass.dashboard_routes.PaymentMethods)
            }} animated>
                <span>
                    {t("pay")}
                </span>
            </Button>

            <Button className={st.btn} outlined>
                <span>
                    {t("pay_anticipated")}
                </span>

                <span>
                    {credit?.disc_amount && CommonClass.formatMoneyAmount(Number(credit?.disc_amount))} {t("currency")}
                </span>
            </Button>
        </div>
    )
}


export default CrLinePage